import axios from 'axios';
import { urlsToMutate } from './useGenericSWR';
import { DateTime } from 'luxon';
import { domain } from '../domain';

export class ApiClient {
    constructor() {
        this.getDefaultItem = () => {
            return { id: 0, }
        };
    }

    fetchUrls = [];
    swrConfig = null;
    mutateFetchUrls = () => {
        while (this.fetchUrls.length > 0) {
            var url = this.fetchUrls.pop();
            urlsToMutate.push({ url: url, data: null });
        }
    };
    addMutateUrl = (url) => {
        urlsToMutate.push({ url: url, data: null});
    }
    axiosConfig = {
        headers: {
            "Content-Type": "application/json",
            "SubDomain": domain.subDomain,
        },
    };

    // Was really hoping not to have to implement something like this
    // SWR should handle this and does within a single route, on changing routes it refreshes everything again
    cacheUrlExipiration = [];
    cacheExirationMs = 10 * 60 * 1000; //10 minutes by default

    fetcher = async (url) => {
        let cache = null;
        if (this.swrConfig) {
            cache = this.swrConfig.cache;
        }

        if (cache && this.cacheUrlExipiration[url] && DateTime.now() < this.cacheUrlExipiration[url]) {
            const cachedResult = cache.get(url);
            if (cachedResult) {
                // swr has it cached so use the cached result
                return cachedResult;
            }
        }

        // Only add distinct urls
        if (this.fetchUrls.indexOf(url) === -1) {
            this.fetchUrls.push(url);
        }

        if (url.endsWith('/0')) {
            // No need for an api request for a new item
            return this.getDefaultItem();
        }

        return axios.get(url, this.axiosConfig)
            .then((res) => {
                this.cacheUrlExipiration[url] = DateTime.now().plus(this.cacheExirationMs);
                return res.data;
            })
            .catch((error) => {
                console.error('ApiClient.fetcher', error);
                throw error;
            });
    };
    poster = async (url, data) => {
        return axios.post(url, data, this.axiosConfig)
            .then((res) => {
                this.mutateFetchUrls();
                return res.data;
            })
            .catch((error) => {
                console.error('ApiClient.poster', error);
                throw error;
            });
    };
}